import {ajaxGetData} from 'methods/ajaxData';
import EmailAuthStep from './steps/email-auth-step';

function AuthTypeHotel(modal) {
    this.modal = modal;
    this.title = 'Я отельер';
    this.name  = 'hotel';
}

AuthTypeHotel.prototype.authorized = function() {
    return new Promise((resolve, reject) => {
        if (typeof this.authData != 'undefined') {
            resolve(this.authData);
            return;
        }

        ajaxGetData().then(r => {
            if (r.data.hotel_auth) {
                resolve(this.authData = this.getAuthFormatted(r.data.hotel_auth));
                return;
            }

            reject(`Not authorized as ${this.name}`);
        });
    });
}

AuthTypeHotel.prototype.auth = function(data) {
    return this.authorized().catch(() => {
        return this.modal.showStep(new EmailAuthStep(this.modal))
            .auth(data)
            .then(auth => {
                return this.authData = this.getAuthFormatted(auth);
            });
    });
}

AuthTypeHotel.prototype.getAuthFormatted = function(data) {
    return Object.assign({}, data, {type: this.name});
}

export default AuthTypeHotel;
